// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles
parcelRequire = (function (modules, cache, entry, globalName) {
  // Save the require from previous bundle to this closure if any
  var previousRequire = typeof parcelRequire === 'function' && parcelRequire;
  var nodeRequire = typeof require === 'function' && require;

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire = typeof parcelRequire === 'function' && parcelRequire;
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error('Cannot find module \'' + name + '\'');
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = cache[name] = new newRequire.Module(name);

      modules[name][0].call(module.exports, localRequire, module, module.exports, this);
    }

    return cache[name].exports;

    function localRequire(x){
      return newRequire(localRequire.resolve(x));
    }

    function resolve(x){
      return modules[name][1][x] || x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [function (require, module) {
      module.exports = exports;
    }, {}];
  };

  var error;
  for (var i = 0; i < entry.length; i++) {
    try {
      newRequire(entry[i]);
    } catch (e) {
      // Save first error but execute all entries
      if (!error) {
        error = e;
      }
    }
  }

  if (entry.length) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(entry[entry.length - 1]);

    // CommonJS
    if (typeof exports === "object" && typeof module !== "undefined") {
      module.exports = mainExports;

    // RequireJS
    } else if (typeof define === "function" && define.amd) {
     define(function () {
       return mainExports;
     });

    // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }

  // Override the current require with this new one
  parcelRequire = newRequire;

  if (error) {
    // throw error from earlier, _after updating parcelRequire_
    throw error;
  }

  return newRequire;
})({"core/utils/element-exists.js":[function(require,module,exports) {
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const elementExists = function elementExists(element) {
  let is_array = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  let exists = element && typeof element !== 'undefined' && element !== null;

  if (exists && is_array) {
    exists = element.length > 0;
  }

  return exists;
};

var _default = elementExists;
exports.default = _default;
},{}],"core/utils/form-serialize.js":[function(require,module,exports) {
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const formSerialize = function formSerialize(form) {
  var i = void 0,
      j = void 0,
      len = void 0,
      jLen = void 0,
      formElement = void 0,
      q = [];

  function urlencode(str) {
    // http://kevin.vanzonneveld.net
    // Tilde should be allowed unescaped in future versions of PHP (as reflected below), but if you want to reflect current
    // PHP behavior, you would need to add ".replace(/~/g, '%7E');" to the following.
    return encodeURIComponent(str).replace(/!/g, '%21').replace(/'/g, '%27').replace(/\(/g, '%28').replace(/\)/g, '%29').replace(/\*/g, '%2A').replace(/%20/g, '+');
  }

  function addNameValue(name, value) {
    q.push(urlencode(name) + '=' + urlencode(value));
  }

  if (!form || !form.nodeName || form.nodeName.toLowerCase() !== 'form') {
    throw 'You must supply a form element';
  }

  for (i = 0, len = form.elements.length; i < len; i++) {
    formElement = form.elements[i];

    if (formElement.name === '' || formElement.disabled) {
      continue;
    }

    switch (formElement.nodeName.toLowerCase()) {
      case 'input':
        switch (formElement.type) {
          case 'text':
          case 'hidden':
          case 'password':
          case 'button': // Not submitted when submitting form manually, though jQuery does serialize this and it can be an HTML4 successful control

          case 'submit':
            addNameValue(formElement.name, formElement.value);
            break;

          case 'checkbox':
          case 'radio':
            if (formElement.checked) {
              addNameValue(formElement.name, formElement.value);
            }

            break;

          case 'file':
            // addNameValue(formElement.name, formElement.value); // Will work and part of HTML4 "successful controls", but not used in jQuery
            break;

          case 'reset':
            break;
        }

        break;

      case 'textarea':
        addNameValue(formElement.name, formElement.value);
        break;

      case 'select':
        switch (formElement.type) {
          case 'select-one':
            addNameValue(formElement.name, formElement.value);
            break;

          case 'select-multiple':
            for (j = 0, jLen = formElement.options.length; j < jLen; j++) {
              if (formElement.options[j].selected) {
                addNameValue(formElement.name, formElement.options[j].value);
              }
            }

            break;
        }

        break;

      case 'button':
        // jQuery does not submit these, though it is an HTML4 successful control
        switch (formElement.type) {
          case 'reset':
          case 'submit':
          case 'button':
            addNameValue(formElement.name, formElement.value);
            break;
        }

        break;
    }
  }

  return q.join('&');
};

var _default = formSerialize;
exports.default = _default;
},{}],"core/utils/index.js":[function(require,module,exports) {
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cartesian = exports.asyncForEach = exports.ajax = void 0;
Object.defineProperty(exports, "elementExists", {
  enumerable: true,
  get: function () {
    return _elementExists.default;
  }
});
Object.defineProperty(exports, "formSerialize", {
  enumerable: true,
  get: function () {
    return _formSerialize.default;
  }
});
exports.serialize = exports.observeRemove = exports.observeAdd = exports.insertSortedValue = exports.getQueryValue = void 0;

var _elementExists = _interopRequireDefault(require("./element-exists"));

var _formSerialize = _interopRequireDefault(require("./form-serialize"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const ajax = async function ajax(method, url) {
  let data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  let contentType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'application/json';
  let xhttp = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  return new Promise(resolve => {
    if (!xhttp) {
      xhttp = new XMLHttpRequest();
    }

    xhttp.onreadystatechange = function () {
      if (xhttp.readyState === 4) {
        resolve(JSON.stringify({
          status: xhttp.status,
          response: xhttp.responseText
        }));
      }
    };

    xhttp.open(method, url, true);

    if (method === 'POST' && data) {
      xhttp.setRequestHeader('Content-type', contentType);
      xhttp.send(JSON.stringify(data));
    } else {
      xhttp.send();
    }

    return xhttp;
  });
};

exports.ajax = ajax;

const observeAdd = async (container, callback) => {
  new MutationObserver((mutationsList, observer) => {
    for (let mutation of mutationsList) {
      if (mutation.type === 'childList') {
        let nodes = [].slice.call(mutation.addedNodes);

        if (nodes.length > 0) {
          callback(nodes);
        }
      }
    }
  }).observe(container, {
    attributes: true,
    childList: true,
    subtree: true
  });
};

exports.observeAdd = observeAdd;

const observeRemove = async (container, callback) => {
  new MutationObserver((mutationsList, observer) => {
    for (let mutation of mutationsList) {
      if (mutation.type === 'childList') {
        let nodes = [].slice.call(mutation.removedNodes);

        if (nodes.length > 0) {
          callback(nodes);
        }
      }
    }
  }).observe(container, {
    attributes: true,
    childList: true,
    subtree: true
  });
};

exports.observeRemove = observeRemove;

const cartesian = function cartesian() {
  for (var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++) {
    a[_key] = arguments[_key];
  }

  return a.reduce((a, b) => a.flatMap(d => b.map(e => [d, e].flat())));
};
/*
  General purpose functions
  Use these functions to apply certain operation in your context
*/


exports.cartesian = cartesian;

const insertSortedValue = fn => (arr, value) => [...arr.filter(n => !fn(n, value)), value, ...arr.filter(n => fn(n, value))];

exports.insertSortedValue = insertSortedValue;

const serialize = form => Array.from(new FormData(form), e => e.map(encodeURIComponent).join('=')).join('&');

exports.serialize = serialize;

const getQueryValue = value => new URLSearchParams(window.location.search).get(value);

exports.getQueryValue = getQueryValue;

const asyncForEach = async (array, callback) => {
  for (let index = 0; index < array.length; index++) {
    await callback(array[index], index, array);
  }
};

exports.asyncForEach = asyncForEach;
},{"./element-exists":"core/utils/element-exists.js","./form-serialize":"core/utils/form-serialize.js"}],"core/components/cart-drawer.js":[function(require,module,exports) {
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _utils = require("../utils");

const CartDrawer = function CartDrawer(cartSelector, triggerSelector) {
  const cartElement = document.querySelector(cartSelector);
  const triggerElement = document.querySelectorAll(triggerSelector);

  if ((0, _utils.elementExists)(triggerElement, true) && (0, _utils.elementExists)(cartElement)) {
    triggerElement.forEach(el => {
      el.addEventListener('click', function ($e) {
        $e.preventDefault();
        cartElement.classList.toggle('open');
      });
    });
  }
};

var _default = CartDrawer;
exports.default = _default;
},{"../utils":"core/utils/index.js"}],"core/services/event-bus.js":[function(require,module,exports) {
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/** 
 * EventBus
 * Defines expected events
 * disppatches events by type
 * handles event listeners by type
 **/
const eventBus = {
  types: {
    AddingToCart: 'mx_shopify.cart.adding',
    AddedToCart: 'mx_shopify.cart.added',
    GettingCart: 'mx_shopify.cart.getting',
    CartUpdated: 'mx_shopify.cart.updated',
    RemovedFromCart: 'mx_shopify.cart.removed',
    QuantityUpdated: 'mx_shopify.quantity.updated',
    OptionsSelected: 'mx_shopify.options.selected',
    AjaxCartRefreshed: 'mx_shopify.cart.ajax.refreshed'
  },

  dispatch($event, $data) {
    $data = typeof $data !== 'undefined' ? $data : {};
    document.dispatchEvent(new CustomEvent($event, {
      detail: $data
    }));
  },

  on($event, func) {
    document.addEventListener($event, func);
  },

  off($event, func) {
    document.removeEventListener($event, func);
  }

};
var _default = eventBus;
exports.default = _default;
},{}],"core/utils/dom.js":[function(require,module,exports) {
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.value = exports.toggleClassAll = exports.toggleClass = exports.toggleAttr = exports.submit = exports.styles = exports.setText = exports.setHtml = exports.setAttr = exports.selectDoc = exports.selectArr = exports.selectAll = exports.select = exports.removeClassAll = exports.removeClass = exports.removeAttribute = exports.remove = exports.prevSibling = exports.opacity = exports.nextSibling = exports.mapDOMElements = exports.isVisible = exports.hasClass = exports.getElems = exports.getAttr = exports.event = exports.dataValue = exports.closest = exports.addClassAll = exports.addClass = void 0;

/*
  General DOM functions
  Use these functions to select, handle html elements (similar to jQuery)
*/
const mapDOMElements = fn => items => [...items].forEach(fn);

exports.mapDOMElements = mapDOMElements;

const selectAll = function selectAll(query) {
  let item = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
  return item.querySelectorAll(query);
};

exports.selectAll = selectAll;

const selectArr = function selectArr(query) {
  let item = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
  return [].slice.call(item.querySelectorAll(query));
};

exports.selectArr = selectArr;

const select = function select() {
  let item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  let query = arguments.length > 1 ? arguments[1] : undefined;
  return item.querySelector(query);
};

exports.select = select;

const selectDoc = function selectDoc(query) {
  let item = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
  return item.querySelector(query);
};

exports.selectDoc = selectDoc;

const value = function value(query) {
  let item = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
  return item.querySelector(query).value;
};

exports.value = value;

const getElems = function getElems(query) {
  let item = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
  return [...item.querySelectorAll(query)];
};

exports.getElems = getElems;

const dataValue = _ref => {
  let {
    dataset
  } = _ref;
  return id => dataset[id];
};

exports.dataValue = dataValue;

const removeAttribute = tag => item => item.removeAttribute(tag);

exports.removeAttribute = removeAttribute;

const closest = item => query => item.closest(query);

exports.closest = closest;

const remove = item => item.parentNode.removeChild(item);

exports.remove = remove;

const nextSibling = item => item.nextElementSibling;

exports.nextSibling = nextSibling;

const prevSibling = item => item.previousElementSibling;

exports.prevSibling = prevSibling;

const toggleAttr = (item, attr) => item.toggleAttribute(attr);

exports.toggleAttr = toggleAttr;

const setAttr = (attr, value) => item => item.setAttribute(attr, value);

exports.setAttr = setAttr;

const getAttr = attr => item => item.getAttribute(attr);

exports.getAttr = getAttr;

const submit = item => item.submit(item);

exports.submit = submit;

const toggleClass = (item, cls) => item.classList.toggle(cls);

exports.toggleClass = toggleClass;

const setText = item => text => item.innerText = text;

exports.setText = setText;

const setHtml = item => html => item.innerHTML = html;

exports.setHtml = setHtml;

const opacity = value => item => item.style.opacity = "".concat(value);

exports.opacity = opacity;

const styles = (elem, styles) => elem.setAttribute("style", Object.entries(styles).map(_ref2 => {
  let [key, value] = _ref2;
  return "".concat(key, ": ").concat(value, ";");
}).join(' '));

exports.styles = styles;

const hasClass = (target, className) => new RegExp('(\\s|^)' + className + '(\\s|$)').test(target.className);

exports.hasClass = hasClass;

const isVisible = elem => !!elem && !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length); // source (2018-03-11): https://github.com/jquery/jquery/blob/master/src/css/hiddenVisibleSelectors.js


exports.isVisible = isVisible;

const removeClassAll = (list, cls) => list.map(l => l.classList.remove(cls));

exports.removeClassAll = removeClassAll;

const addClassAll = (list, cls) => list.map(l => l.classList.add(cls));

exports.addClassAll = addClassAll;

const addClass = (e, cls) => !hasClass(e, cls) ? e.classList.add(cls) : false;

exports.addClass = addClass;

const removeClass = (e, cls) => hasClass(e, cls) ? e.classList.remove(cls) : false;

exports.removeClass = removeClass;

const toggleClassAll = (items, cls) => [].slice.call(items).map(item => item.classList.toggle(cls));

exports.toggleClassAll = toggleClassAll;

const event = (elem, event, func) => elem ? elem.addEventListener(event, func) : console.log('Invalid element to apply ' + event + ': ' + func);

exports.event = event;
},{}],"core/components/product-form.js":[function(require,module,exports) {
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _eventBus = _interopRequireDefault(require("../services/event-bus"));

var _dom = require("../utils/dom");

var _elementExists = _interopRequireDefault(require("../utils/element-exists"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { selectDoc, addClass , removeClass } from "../utils/utils";
let ProductForm = function ProductForm() {
  let $product_or_id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  let $container = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  let $this = {};
  $this.product_or_id = $product_or_id;
  if ($container) $this.container = $container;
  $this.productSelect = false;
  $this.productJson = false;
  $this.variantOptions = {};
  $this.optionsInitialized = false;
  $this.classes = {
    cartPopupWrapperHidden: 'cart-popup-wrapper--hidden',
    hidden: 'd-none',
    visibilityHidden: 'sr-only',
    inputError: 'input--error',
    productOnSale: 'price--on-sale',
    productUnitAvailable: 'price--unit-available',
    productUnavailable: 'price--unavailable',
    productSoldOut: 'price--sold-out',
    cartImage: 'cart-popup-item__image',
    productFormErrorMessageWrapperHidden: 'product-form__error-message-wrapper--hidden',
    variantSoldOut: 'product-form--variant-sold-out',
    addingToCart: 'loading'
  };
  $this.selectors = {
    addToCart: '[sh-add-to-cart]',
    addToCartText: '[sh-add-to-cart-text]',
    loader: '[data-loader]',
    productForm: '[data-product-form]',
    priceContainer: '[data-price]',
    regularPrice: '[data-regular-price]',
    salePrice: '[data-sale-price]',
    unitPrice: '[data-unit-price]',
    unitPriceBaseUnit: '[data-unit-price-base-unit]',
    productPolicies: '[data-product-policies]',
    swatchOptions: '[data-swatch-option]',
    swatchValues: '[data-swatch-value]',
    optionSelect: '[sh-option-select]'
  };

  $this.init = function () {
    if ($this.product_or_id) {
      // if product init product 
      let product = $this.validateProduct($this.product_or_id);

      if (product) {
        $this.initProduct(product, $this.product_or_id);
      }
    }
  };

  $this.validateProduct = function (product_or_id) {
    let product = false;

    if (typeof product_or_id == 'object') {
      product = product_or_id;
    } else if (typeof product_or_id == 'string') {
      try {
        product = JSON.parse(document.getElementById('ProductJson-' + product_or_id).innerHTML);
      } catch ($e) {
        product = false;
      }
    }

    return product;
  };
  /** 
   * Accepts a product object or id
   * If a product object is passed, it expects the container and ProductSelect
   * to have the product ID specifically on their ids ProductXXX-product.id
   *
   */


  $this.initProduct = function (product, product_or_id) {
    $this.product = product;
    let select = $this.container.querySelector($this.selectors.optionSelect);

    if ((0, _elementExists.default)(select)) {
      $this.productSelect = select.getAttribute('id');
    } else {
      $this.productSelect = false;
    } // $this.createOptionMap();


    $this.addElements(); // $this.QuantityComponent = new $theme.QuantityComponent( $this.container.find( '[sh-quantity-component]') )
    // // initialize product selector 

    if ($this.product.variants.length > 1 && $this.productSelect) {
      $this.addSelectCallBack();
    } // // add to cart handler


    $this.form.addEventListener('submit', function ($e) {
      $e.preventDefault();
      $this.addToCart();
    }); // return $this.product;
  };

  $this.addElements = function () {
    $this.form = $this.container.querySelector($this.selectors.productForm);
    $this.$addToCart = $this.container.querySelector($this.selectors.addToCart);
    $this.$addToCartText = $this.container.querySelector($this.selectors.addToCartText);
    $this.swatchOptions = $this.container.querySelector($this.selectors.swatchOptions);
    $this.swatchValues = $this.container.querySelector($this.selectors.swatchValues); // if( $this.swatchOptions.length > 0 ){
    // 	$this.initSwatchOptions();
    // }   

    $this.priceContainer = this.container.querySelector($this.selectors.priceContainer);
    $this.regularPrice = $this.priceContainer.querySelector($this.selectors.regularPrice);
    $this.salePrice = $this.priceContainer.querySelector($this.selectors.salePrice);
    $this.unitPrice = $this.priceContainer.querySelector($this.selectors.unitPrice);
    $this.unitPriceBaseUnit = $this.priceContainer.querySelector($this.selectors.unitPriceBaseUnit);
  };

  $this.addSelectCallBack = function () {
    let selector = new Shopify.OptionSelectors($this.productSelect, {
      product: $this.product,
      onVariantSelected: $this.selectCallback
    });
  };

  $this.selectCallback = function (variant, selector) {
    if ($this.optionsInitialized == false) {
      $this.initOptionSelectors();
    }

    $this.variant = variant;
    $this.resetState();
    $this.updatePrice(); // $this.updateAddToCart(  );

    _eventBus.default.dispatch(_eventBus.default.types.OptionsSelected, variant);
  };

  $this.resetState = function () {
    (0, _dom.removeClass)($this.priceContainer, $this.classes.productUnavailable);
    (0, _dom.removeClass)($this.priceContainer, $this.classes.productOnSale);
    (0, _dom.removeClass)($this.priceContainer, $this.classes.productSoldOut);
    $this.priceContainer.removeAttribute('aria-hidden');
    (0, _dom.removeClass)($this.container, $this.classes.productUnavailable);
    (0, _dom.removeClass)($this.container, $this.classes.productOnSale);
    (0, _dom.removeClass)($this.container, $this.classes.productUnitAvailable);
    (0, _dom.removeClass)($this.container, $this.classes.productSoldOut);
    $this.container.removeAttribute('aria-hidden');
  };

  $this.updatePrice = function () {
    // this.$productPolicies.removeClass(this.classes.visibilityHidden);		
    // Unavailable
    if (!$this.variant) {
      $this.update_variant_unavailable();
      return;
    } // Sold out


    if (!$this.variant.available) {
      $this.update_variant_unavailable();
    } // On sale


    if ($this.variant.compare_at_price > $this.variant.price) {
      $this.update_variant_on_sale();
    } else {
      $this.update_variant_regular();
    } // Unit price


    if ($this.variant.unit_price) {
      $this.update_variant_unit();
    }
  }; // $this.createOptionMap = function(){
  // 	$this.optionsMap = [];
  // 	for (var i=0; i<$this.product.variants.length; i++) {
  // 		var variant = $this.product.variants[i];
  // 		if (variant.available) {
  // 			// Gathering values for the 1st drop-down.
  // 			$this.optionsMap['root'] = $this.optionsMap['root'] || [];
  // 			$this.optionsMap['root'].push(variant.option1);
  // 			$this.optionsMap['root'] = Shopify.uniq($this.optionsMap['root']);
  // 			// Gathering values for the 2nd drop-down.
  // 			if ($this.product.options.length > 1) {
  // 				var key = variant.option1;
  // 				$this.optionsMap[key] = $this.optionsMap[key] || [];
  // 				$this.optionsMap[key].push(variant.option2);
  // 				$this.optionsMap[key] = Shopify.uniq($this.optionsMap[key]);
  // 			}
  // 			// Gathering values for the 3rd drop-down.
  // 			if ($this.product.options.length === 3) {
  // 				var key = variant.option1 + ' / ' + variant.option2;
  // 				$this.optionsMap[key] = $this.optionsMap[key] || [];
  // 				$this.optionsMap[key].push(variant.option3);
  // 				$this.optionsMap[key] = Shopify.uniq($this.optionsMap[key]);
  // 			}
  // 		}
  // 	}
  // }
  // $this.initOptionSelectors = function(){
  // 	$this.optionsInitialized = true;
  // 	// Update options right away.
  // 	$this.updateOptionsInSelector(0);
  // 	if ($this.product.options.length > 1) $this.updateOptionsInSelector(1);
  // 	if ($this.product.options.length === 3) $this.updateOptionsInSelector(2);
  // 	// When there is an update in the first dropdown.
  // 	$(".single-option-selector:eq(0)").change(function() {
  // 		$this.updateOptionsInSelector(1);
  // 		if ($this.product.options.length === 3) $this.updateOptionsInSelector(2);
  // 		return true;
  // 	});
  // 	// When there is an update in the second dropdown.
  // 	$(".single-option-selector:eq(1)").change(function() {
  // 		if ($this.product.options.length === 3) $this.updateOptionsInSelector(2);
  // 		return true;
  // 	});  
  // 	if( $this.product.options.length > 0){
  // 		if( $(".single-option-selector:eq(0) option").length == 1 ){
  // 			$(".single-option-selector:eq(0)").addClass('single-option')
  // 		} 
  // 	}
  // 	if( $this.product.options.length > 1){
  // 		if( $(".single-option-selector:eq(1) option").length == 1 ){
  // 			$(".single-option-selector:eq(1)").addClass('single-option')
  // 		} 
  // 	}
  // 	if( $this.product.options.length > 2){
  // 		if( $(".single-option-selector:eq(2) option").length == 1 ){
  // 			$(".single-option-selector:eq(2)").addClass('single-option')
  // 		} 
  // 	}
  // }
  // $this.updateOptionsInSelector = function(selectorIndex) {
  // 	switch (selectorIndex) {
  // 		case 0:
  // 		var key = 'root';
  // 		var selector = $('.single-option-selector:eq(0)');
  // 		break;
  // 		case 1:
  // 		var key = $('.single-option-selector:eq(0)').val();
  // 		var selector = $('.single-option-selector:eq(1)');
  // 		break;
  // 		case 2:
  // 		var key = $('.single-option-selector:eq(0)').val();  
  // 		key += ' / ' + $('.single-option-selector:eq(1)').val();
  // 		var selector = $('.single-option-selector:eq(2)');
  // 	}
  // 	var initialValue = selector.val();
  // 	selector.empty();    
  // 	var availableOptions = $this.optionsMap[key];
  // 	if( typeof( availableOptions ) == 'undefined') return;
  // 	for (var i=0; i<availableOptions.length; i++) {
  // 		var option = availableOptions[i];
  // 		var newOption = $('<option></option>').val(option).html(option);
  // 		selector.append(newOption);
  // 	}
  // 	if ($.inArray(initialValue, availableOptions) !== -1) {
  // 		selector.val(initialValue);
  // 	}
  // 	if( $this.swatchOptions.length > 0 ){
  // 		$('.swatch[data-option-index="' + selectorIndex + '"] .swatch-element').each(function() {
  // 			let $value = $(this).data('value') 
  // 			let option= $(this)
  // 			if ($.inArray($value, availableOptions) !== -1) {
  // 				option.show().find(':radio').removeAttr('disabled','disabled')
  // 				if( $this.variant != null ){
  // 					if( selectorIndex == 0  && $value == $this.variant.option1 ){
  // 						option.attr( 'checked' , 'checked' );
  // 					}
  // 					if( selectorIndex == 1  && $value == $this.variant.option2 ) {
  // 						option.attr( 'checked' , 'checked' );
  // 					}
  // 					if( selectorIndex == 2  && $value == $this.variant.option3 ) {
  // 						option.attr( 'checked' , 'checked' );
  // 					}
  // 				}
  // 			}else {
  // 				option.hide().find(':radio').removeAttr('checked').attr('disabled','disabled');
  // 			}
  // 		});
  // 		if( $this.variant == null ){
  // 			var first = $($("input[name='option-"+ selectorIndex+"']")[0]);
  // 			first.trigger( 'click')
  // 		}
  // 	}
  // 	selector.trigger('change');
  // 	};
  // update the add to cart button on variant change 
  // $this.updateAddToCart =  function( ){		
  // 	if ($this.variant) {
  // 		if ($this.variant.available) {
  // 			removeAttr($this.$addToCart , 'aria-disabled')
  // 			$this.$addToCart.setAttribute('aria-label', theme.strings.addToCart);
  // 			$($this.selectors.addToCartText, $this.container ).text( theme.strings.addToCart );
  // 			$($this.selectors.productForm, $this.container ).removeClass( $this.classes.variantSoldOut );
  // 		} else {
  // 			// Variant is sold out, disable submit button and change the text.
  // 			$this.$addToCart
  // 				.attr('aria-disabled', true)
  // 				.attr('aria-label', theme.strings.soldOut);
  // 			$($this.selectors.addToCartText, $this.container ).text( theme.strings.soldOut );
  // 			$($this.selectors.productForm, $this.container ).addClass( $this.classes.variantSoldOut );
  // 		}
  // 	} else {
  // 		// The variant doesn't exist, disable submit button and change the text.
  // 		$this.$addToCart
  // 			.attr('aria-disabled', true)
  // 			.attr('aria-label', theme.strings.unavailable);
  // 		$($this.selectors.addToCartText, $this.container ).text( theme.strings.unavailable );
  // 		$($this.selectors.productForm, $this.container ).addClass( $this.classes.variantSoldOut );
  // 	}
  // },


  $this.update_variant_unavailable = function () {
    addClass($this.container, $this.classes.productUnavailable);
    addClass($this.priceContainer, $this.classes.productUnavailable).attr('aria-hidden', true); // this.$productPolicies.addClass(this.classes.visibilityHidden);
  };

  $this.update_variant_regular = function () {
    $this.regularPrice.innerHTML(Shopify.formatMoney($this.variant.price));
  };

  $this.update_variant_on_sale = function () {
    $this.regularPrice.innerHtml(Shopify.formatMoney($this.variant.compare_at_price));
    $this.salePrice.innerHtml(Shopify.formatMoney($this.variant.price));
    addClass($this.priceContainer, $this.classes.productOnSale);
  };

  $this.update_variant_unit = function () {
    $this.unitPrice.innerHtml($theme.Currency.formatMoney($this.variant.unit_price, $theme.moneyFormat));
    $this.unitPriceBaseUnit.innerHtml($this._getBaseUnit($this.variant));
    addClass($this.priceContainer, $this.classes.productUnitAvailable);
  };

  $this.addToCart = function ($data) {
    let formData = Object.assign(...Array.from(new FormData($this.form).entries(), _ref => {
      let [x, y] = _ref;
      return {
        [x]: y
      };
    }));

    _eventBus.default.dispatch(_eventBus.default.types.AddingToCart, $this.product);

    const data = {
      'items': [{
        'id': formData.id,
        'quantity': formData.quantity
      }]
    };
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    }).then(response => {
      response.json().then(json => {
        const variant = json.items[0];

        _eventBus.default.dispatch(_eventBus.default.types.AddedToCart, {
          variant: variant,
          success: true
        });
      });
    }).catch(error => {
      alert('There was an error adding your item to the cart');
    });
  }; // $this.initSwatchOptions = function( ){
  // 	let radios = $($this.swatchOptions.find(  ':radio' ) );
  // 	radios.change(function() {
  // 		var optionIndex = $(this).closest($this.selectors.swatchOptions).attr('data-option-index');
  // 		var optionValue = $(this).val();
  // 		$this.form
  // 		.find('.single-option-selector')
  // 		.eq(optionIndex)
  // 		.val(optionValue)
  // 		.trigger('change');
  // 	});
  // }


  return $this;
};

var _default = ProductForm;
exports.default = _default;
},{"../services/event-bus":"core/services/event-bus.js","../utils/dom":"core/utils/dom.js","../utils/element-exists":"core/utils/element-exists.js"}],"core/services/product-forms.js":[function(require,module,exports) {
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _productForm = _interopRequireDefault(require("../components/product-form"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const ProductForms = selector => {
  const forms = document.querySelectorAll(selector);

  if (typeof forms !== 'undefined' && forms.length > 0) {
    forms.forEach(form => {
      const data = form.dataset;

      if (typeof data.productId != 'undefined') {
        let producData = form.querySelector('.product-json');

        try {
          producData = JSON.parse(producData.textContent);
          let product = new _productForm.default(producData, form);
          product.init();
        } catch ($e) {}
      }
    });
  }
};

var _default = ProductForms;
exports.default = _default;
},{"../components/product-form":"core/components/product-form.js"}],"core/components/quantity.js":[function(require,module,exports) {
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _eventBus = _interopRequireDefault(require("../services/event-bus"));

var _elementExists = _interopRequireDefault(require("../utils/element-exists"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** 
 * QuantiyButton Component
 * expects a wrapper element 
 * requires element to have three defined data elements
 * for increase and decrease buttons and the quantitiy input
 * Dispatches an event for use in cart 
 **/
let QuantityComponent = function QuantityComponent($containerElement) {
  let $this = {};

  $this.init = function () {
    $this.defaults = {
      minValue: 0,
      maxValue: 1000
    };
    $this.timeout = false;
    $this.container = $containerElement;
    $this.data = $containerElement.dataSet;
    $this.data = Object.assign($this.defaults, $this.data);
    $this.quantityDec = $this.container.querySelector('[data-quantity-dec]');
    $this.quantityInc = $this.container.querySelector('[data-quantity-inc]');
    $this.quantityInput = $this.container.querySelector('[data-quantity-input]');

    if ((0, _elementExists.default)($this.quantityDec) && (0, _elementExists.default)($this.quantityInc) && (0, _elementExists.default)($this.quantityInput)) {
      $this.initQuantityInput();
    }
  };

  $this.initQuantityInput = function () {
    $this.quantityDec.addEventListener('click', function () {
      $this.updateQuantity('dec');
    });
    $this.quantityInc.addEventListener('click', function () {
      $this.updateQuantity('inc');
    });
    $this.quantityInput.addEventListener('keyup', function () {
      let $val = parseInt($this.quantityInput.value);
      $this.timeout = setTimeout(function () {
        _eventBus.default.dispatch(_eventBus.default.types.QuantityUpdated, {
          target: $this.container,
          value: $val
        });
      }, 250);
    });
  };

  $this.updateQuantity = function ($dir) {
    clearTimeout($this.timeout);
    let $val = parseInt($this.quantityInput.value);

    if ($dir == 'dec') {
      if ($val == $this.data.minValue) return;
      $val -= 1;
    }

    if ($dir == 'inc') {
      if ($val == $this.data.maxValue) return;
      $val += 1;
    }

    $this.quantityInput.value = $val;
    $this.timeout = setTimeout(function () {
      _eventBus.default.dispatch(_eventBus.default.types.QuantityUpdated, {
        target: $this.container,
        value: $val
      });
    }, 250);
  };

  $this.init();
  return $this;
};

var _default = QuantityComponent;
exports.default = _default;
},{"../services/event-bus":"core/services/event-bus.js","../utils/element-exists":"core/utils/element-exists.js"}],"core/services/quantity-components.js":[function(require,module,exports) {
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _quantity = _interopRequireDefault(require("../components/quantity"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const QuantityComponents = selector => {
  const elements = document.querySelectorAll(selector);

  if (typeof elements !== 'undefined' && elements.length > 0) {
    elements.forEach(el => {
      let quantityComponent = new _quantity.default(el);
    });
  }
};

var _default = QuantityComponents;
exports.default = _default;
},{"../components/quantity":"core/components/quantity.js"}],"core/components/cart-count.js":[function(require,module,exports) {
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _eventBus = _interopRequireDefault(require("../services/event-bus"));

var _utils = require("../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

let CartCount = function CartCount($selector) {
  let $this = {};
  $this.classes = {
    empty: 'empty'
  };

  $this.init = function () {
    $this.elements = document.querySelectorAll($selector);

    if ((0, _utils.elementExists)($this.elements)) {
      // eventBus.on( eventBus.types.AddingToCart  , $this.addingToCart )
      // eventBus.on( eventBus.types.AddedToCart  , $this.addedToCart )
      _eventBus.default.on(_eventBus.default.types.CartUpdated, $this.cartUpdated);
    }
  };

  $this.cartUpdated = function ($event) {
    $this.elements.forEach(el => {
      el.innerText = Shopify.cartService.cart.item_count;
    });
  };

  $this.init();
  return $this;
};

var _default = CartCount;
exports.default = _default;
},{"../services/event-bus":"core/services/event-bus.js","../utils":"core/utils/index.js"}],"core/services/cart.js":[function(require,module,exports) {
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CartService = CartService;
exports.default = void 0;

var _utils = require("../utils");

var _eventBus = _interopRequireDefault(require("./event-bus"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** 
 * Global Cart Service
 * Holds the current state of the cart
 * handles updating quantity and removing items
 * TODO : Move add to cart functionality here. 
 **/
function CartService() {
  let $this = {};
  $this.currentProduct = false;
  $this.productAdded = false;

  $this.init = function () {
    $this.getCart();

    _eventBus.default.on(_eventBus.default.types.AddingToCart, $this.AddingToCart);

    _eventBus.default.on(_eventBus.default.types.AddedToCart, $this.addedToCart);
  };

  $this.AddingToCart = function ($data) {
    $this.currentProduct = $data.detail;
  };

  $this.addedToCart = function ($data) {
    $this.productAdded = $data;
    $this.getCart();
  };

  $this.getCart = function () {
    (0, _utils.ajax)('GET', '/cart.json').then(res => {
      res = JSON.parse(res);
      res = JSON.parse(res.response);
      $this.cart = res;

      _eventBus.default.dispatch(_eventBus.default.types.CartUpdated, $this.cart);
    });
  };

  $this.removeItem = function (key) {
    const $promise = new Promise(function (resolve, reject) {
      (0, _utils.ajax)('POST', '/cart/change.js', {
        quantity: 0,
        id: key
      }).then(function (res) {
        let jsonResponse = JSON.parse(res);
        let jsonData = JSON.parse(jsonResponse.response);
        $this.cart = jsonData;
        resolve({
          cart: $this.cart,
          success: true
        });

        _eventBus.default.dispatch(_eventBus.default.RemovedFromCart, {
          cart: $this.cart,
          key: key
        });

        _eventBus.default.dispatch(_eventBus.default.types.CartUpdated, $this.cart);
      });
    });
    return $promise;
  };

  $this.updateQuantity = function (key, value) {
    const $promise = new Promise(function (resolve, reject) {
      (0, _utils.ajax)('POST', '/cart/change.js', {
        quantity: value,
        id: key
      }).then(function (res) {
        let jsonResponse = JSON.parse(res);
        let jsonData = JSON.parse(jsonResponse.response);
        $this.cart = jsonData;
        resolve({
          cart: $this.cart,
          success: true
        });

        _eventBus.default.dispatch(_eventBus.default.types.CartUpdated, $this.cart);
      });
    });
    return $promise;
  }; // $this.updateQuantity__update = function( updates ){
  //     let $promise = new Promise(function(resolve, reject) {
  //         var params = {
  //             url: '/cart/update.js',
  //             data: {  updates : updates } ,
  //             dataType: 'json'
  //         };
  //         $.post(params)
  //             .done( function( res ) { 
  //                 $this.cart = res;
  //                 resolve( { cart : res , success : true })
  //                 eventBus.dispatch( eventBus.types.CartUpdated  , $this.cart )
  //             } )
  //             .fail( function() { 
  //                     resolve( { success : false })
  //             } );			
  //     } );
  //     return $promise
  // }		


  $this.init();
  return $this;
}

var _default = CartService;
exports.default = _default;
},{"../utils":"core/utils/index.js","./event-bus":"core/services/event-bus.js"}],"core/components/add-to-cart-button.js":[function(require,module,exports) {
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _dom = require("../utils/dom");

var _eventBus = _interopRequireDefault(require("../services/event-bus"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** 
 * AddToCartButton Component
 * 
 **/
let AddToCartButton = function AddToCartButton($element) {
  let $this = {};
  $this.classes = {
    loading: 'loading',
    productId: false
  };
  $this.selectors = {
    addToCartText: '[sh-add-to-cart-text]'
  };

  $this.init = function () {
    $this.element = $element;
    $this.productId = $this.element.dataset.productId;
    $this.addToCartText = $this.element.querySelector($this.selectors.addToCartText);

    _eventBus.default.on(_eventBus.default.types.AddingToCart, $this.addingToCart);

    _eventBus.default.on(_eventBus.default.types.AddedToCart, $this.addedToCart);
  };

  $this.addingToCart = function ($data) {
    if ($this.productId == $data.detail.id) {
      (0, _dom.addClass)($this.element, $this.classes.loading);
      $this.addToCartText.innerText = 'Adding...';
    }
  };

  $this.addedToCart = function ($data) {
    if ($data.detail.success == true) {
      if ($this.productId == $data.detail.variant.product_id) {
        (0, _dom.removeClass)($this.element, $this.classes.loading);
        $this.addToCartText.innerText = 'Cart Updated.';
        window.setTimeout(function () {
          $this.addToCartText.innerText = 'Add To Cart';
        }, 1000);
      }
    }
  };

  $this.init();
  return $this;
};

var _default = AddToCartButton;
exports.default = _default;
},{"../utils/dom":"core/utils/dom.js","../services/event-bus":"core/services/event-bus.js"}],"core/services/add-to-cart-buttons.js":[function(require,module,exports) {
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _addToCartButton = _interopRequireDefault(require("../components/add-to-cart-button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const AddToCartButtons = selector => {
  const elements = document.querySelectorAll(selector);

  if (typeof elements !== 'undefined' && elements.length > 0) {
    elements.forEach(el => {
      let $btn = (0, _addToCartButton.default)(el);
    });
  }
};

var _default = AddToCartButtons;
exports.default = _default;
},{"../components/add-to-cart-button":"core/components/add-to-cart-button.js"}],"core/components/cart.js":[function(require,module,exports) {
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _elementExists = _interopRequireDefault(require("../utils/element-exists"));

var _eventBus = _interopRequireDefault(require("../services/event-bus"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Cart
 * Cart Display
 * Initializes line item remove + quantity updates
 * Listes for removed and quantity updates
 **/
Shopify.theme = Shopify.theme || {};

let Cart = function Cart(container) {
  let _this = {};
  _this.classes = {
    cartEmpty: 'empty'
  };
  _this.selectors = {
    cartItem: '[data-cart-item]',
    cartRemove: '[data-cart-remove]',
    cartCount: '[data-cart-count]',
    cartSubTotal: '[data-cart-subtotal]',
    cartAjaxContainer: '[data-ajax-container]'
  };
  _this.attributes = {
    sideBarCart: 'data-sidebar-cart',
    cartItemIndex: 'data-cart-item-index',
    cartItemKey: 'data-cart-item-key',
    cartItemQuantity: 'data-cart-item-quantity',
    cartItemTitle: 'data-cart-item-title',
    cartItemUrl: 'data-cart-item-url',
    quantityItem: 'data-quantity-item'
  };

  _this.init = function () {
    _this.container = container;

    _this.initElements();

    _eventBus.default.on(_eventBus.default.types.CartUpdated, _this.onCartUpdated);

    _eventBus.default.on(_eventBus.default.types.QuantityUpdated, _this.onQuantityUpdated); // _this.type =  _this.container.data( 'cart-type' ) == 'sidebar' ? 'sidebar' : 'page';
    // if( _this.type == 'sidebar'){
    // 	eventBus.on( eventBus.types.AddedToCart , function( $item ){
    // 		_this.cartAjaxContainer.load( '/cart?view=ajax', function(){
    // 			eventBus.dispatch( eventBus.types.AjaxCartRefreshed )
    // 			_this.initElements();
    // 		});
    // 	})
    // }

  };

  _this.initElements = function () {
    _this.removeButtons = _this.container.querySelectorAll(_this.selectors.cartRemove);

    if ((0, _elementExists.default)(_this.removeButtons, true)) {
      _this.removeButtons.forEach(btn => {
        btn.addEventListener('click', _this.removeItem);
      });
    }

    _this.cartCount = _this.container.querySelector(_this.selectors.cartCount);
    _this.cartSubTotal = _this.container.querySelector(_this.selectors.cartSubTotal);
    _this.cartAjaxContainer = _this.container.querySelector(_this.selectors.cartAjaxContainer); // $(_this.container.find( '[sh-quantity-component]') ).each( function( $e ){
    // 	( new $theme.QuantityComponent( $(this) ) );
    // });
  }; // fadeOut takes an element and increases the opacity until it fades out


  _this.fadeOut = function (elm) {
    const fadeEffect = setInterval(function () {
      if (!elm.style.opacity) {
        elm.style.opacity = 1;
      }

      if (elm.style.opacity > -0.3) {
        elm.style.opacity -= 0.1;
      } else {
        clearInterval(fadeEffect);
        elm.remove();
      }
    }, 30);
  };

  _this.removeItem = function (e) {
    e.preventDefault();
    const elm = e.target.closest(_this.selectors.cartItem);
    const key = elm.getAttribute(_this.attributes.cartItemKey);
    Shopify.cartService.removeItem(key).then(function (response) {
      if (response.success) {
        const editedItems = document.querySelectorAll("[data-cart-item-key='".concat(key, "']"));
        editedItems.forEach(editedElm => _this.fadeOut(editedElm));
      }
    });
  };

  _this.updateCart = function () {};

  _this.onQuantityUpdated = function (e) {
    e.preventDefault();
    const elm = e.detail.target.closest(_this.selectors.cartItem);
    let key = '';

    if (elm) {
      key = elm.getAttribute(_this.attributes.cartItemKey);
    } // if we have a valid element and key (ie: we're on the cart), update the quantity in cart


    if (elm && key) {
      Shopify.cartService.updateQuantity(key, e.detail.value).then(function (res) {
        const editedItems = document.querySelectorAll("[data-cart-item-key='".concat(key, "']")); // get the recently updated values

        if (res.cart.items) {
          res.cart.items.forEach(item => {
            if (item.key == key) {
              editedItems.forEach(editedElm => {
                editedElm.querySelector('.product-form__qty-input').value = item.quantity;
              });
            }
          });
        }

        if (res.success && e.detail.value == 0) {
          _this.fadeOut(elm);
        }
      });
    }
  };

  _this.onCartUpdated = function (cart) {
    // the cart is empty just hide it.
    if (Shopify.cartService.cart.item_count == 0) {
      _this.container.classList.add(_this.classes.cartEmpty);

      return;
    } else {
      _this.container.classList.remove(_this.classes.cartEmpty);
    } // update the cart count


    if (Shopify.cartService.cart.item_count == 1) {
      _this.cartCount.innerText = Shopify.cartService.cart.item_count + ' Item';
    } else {
      _this.cartCount.innerText = Shopify.cartService.cart.item_count + ' Items';
    } // update the subtotal


    if (_this.cartSubTotal) {
      _this.cartSubTotal.innerText = Shopify.formatMoney(Shopify.cartService.cart.total_price);
    }
  }; // _this.container = $($container);


  _this.init();
};

var _default = Cart;
exports.default = _default;
},{"../utils/element-exists":"core/utils/element-exists.js","../services/event-bus":"core/services/event-bus.js"}],"core/services/carts.js":[function(require,module,exports) {
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _cart = _interopRequireDefault(require("../components/cart"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Carts = selector => {
  const elements = document.querySelectorAll(selector);

  if (typeof elements !== 'undefined' && elements.length > 0) {
    elements.forEach(el => {
      let cart = new _cart.default(el);
    });
  }
};

var _default = Carts;
exports.default = _default;
},{"../components/cart":"core/components/cart.js"}],"request-store-accordion.js":[function(require,module,exports) {
let requestStoreIsShowingAllStores = true;
const requestStoreViewAllBtns = document.querySelectorAll('.view-all-btn');

for (let btn of requestStoreViewAllBtns) {
  btn.addEventListener('click', e => {
    requestStoreIsShowingAllStores = !requestStoreIsShowingAllStores;
    RequestStoreToggleExtraStoreList(e, requestStoreIsShowingAllStores);
  });
}

const RequestStoreToggleExtraStoreList = function RequestStoreToggleExtraStoreList(evt) {
  let isShowing = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  evt.preventDefault();
  isShowing = !isShowing;
  let extraLists = document.querySelectorAll('.collapsible-column');

  for (let list of extraLists) {
    list.classList.toggle('show');

    if (isShowing) {
      list.style.maxHeight = list.scrollHeight + "px";
    } else {
      list.style.maxHeight = "0px";
    }
  }

  RequestStoreSetViewAllButtonText(isShowing);
};

const RequestStoreResizeExtraStoreList = function RequestStoreResizeExtraStoreList() {
  let isShowing = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  let extraLists = document.querySelectorAll('.collapsible-column');

  for (let list of extraLists) {
    if (isShowing) {
      list.style.maxHeight = list.scrollHeight + "px";
    } else {
      list.style.maxHeight = "0px";
    }
  }

  RequestStoreSetViewAllButtonText(isShowing);
};

const RequestStoreSetViewAllButtonText = function RequestStoreSetViewAllButtonText() {
  let isShowing = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  let viewAllBtns = document.querySelectorAll('.view-all-btn');

  if (isShowing) {
    for (let btn of viewAllBtns) {
      btn.innerHTML = "View Less";
    }
  } else {
    for (let btn of viewAllBtns) {
      btn.innerHTML = "View All";
    }
  }
};

window.addEventListener('resize', () => RequestStoreResizeExtraStoreList(!requestStoreIsShowingAllStores));
},{}],"copy-to-clipboard.js":[function(require,module,exports) {
let requestStoreClipboardButton = null;

const RequestStoreCopyToClipboardInit = () => {
  requestStoreClipboardButton = document.querySelector('.clipboard-btn');
  if (!requestStoreClipboardButton) return;
  requestStoreClipboardButton.addEventListener('click', () => RequestStoreCopyToClipboard());
};

const RequestStoreCopyToClipboard = function RequestStoreCopyToClipboard() {
  let text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  if (!text) {
    text = document.querySelector('#clipboard-text').innerHTML;
  }

  navigator.clipboard.writeText(text);
  let bubble = document.querySelector('.feedback-bubble.above');

  if (document.querySelector('#clipboard-text').getBoundingClientRect().top < 275) {
    bubble = document.querySelector('.feedback-bubble.below');
  }

  bubble.classList.add('show');
  setTimeout(() => {
    let bubbles = document.querySelectorAll('.feedback-bubble');

    for (let bubble of bubbles) {
      bubble.classList.remove('show');
    }
  }, 3000);
};

RequestStoreCopyToClipboardInit();
},{}],"faq-accordion.js":[function(require,module,exports) {
window.addEventListener('DOMContentLoaded', e => {
  const faqAccordion = document.querySelector('#faq-accordion');
  const accordionButtons = document.querySelectorAll('.btn-accordion');

  for (let btn of accordionButtons) {
    btn.addEventListener('click', e => {
      const target = btn.getAttribute('data-target');
      const targetElement = document.querySelector(target);
      let expanded = btn.getAttribute('aria-expanded');

      for (let _btn of accordionButtons) {
        _btn.setAttribute('aria-expanded', 'false');

        const _targetElement = document.querySelector(_btn.getAttribute('data-target'));

        _targetElement.classList.remove('open');

        _targetElement.style.maxHeight = '0px';
      }

      if (expanded === 'false') {
        btn.setAttribute('aria-expanded', 'true');
        targetElement.classList.add('open');
        targetElement.style.maxHeight = targetElement.scrollHeight + 'px';
      }
    });
  }
});
},{}],"modal-overlay.js":[function(require,module,exports) {
window.addEventListener('DOMContentLoaded', e => {
  const modalBtns = document.querySelectorAll('.btn-custom-modal, .btn-close-modal');
  const modals = document.querySelectorAll('.custom-modal');
  const modalData = [];

  const ToggleCustomModal = (e, i) => {
    const {
      modal,
      btns
    } = modalData[i];
    if (!modal || !btns) return;

    if (modal.classList.contains('show')) {
      btns.forEach(btn => {
        btn.setAttribute('aria-expanded', 'false');
      });
      modal.classList.remove('show');
      document.body.style.overflow = 'auto';
      return;
    }

    btns.forEach(btn => {
      btn.setAttribute('aria-expanded', 'true');
    });
    modal.classList.add('show');
    document.body.style.overflow = 'hidden';
  }; // Pair all modals with associated btns and add event listeners


  for (let i = 0; i < modals.length; i++) {
    const modalId = modals[i].id;
    const btnArr = [];

    for (let i = 0; i < modalBtns.length; i++) {
      if (modalBtns[i].getAttribute('aria-controls') === '#' + modalId) {
        btnArr.push(modalBtns[i]);
      }
    }

    modalData.push({
      modal: modals[i],
      btns: btnArr
    });

    for (let i = 0; i < btnArr.length; i++) {
      btnArr[i].addEventListener('click', ToggleCustomModal.bind(null, e, modalData.length - 1));
    }
  }
});
},{}],"filtering.js":[function(require,module,exports) {
window.addEventListener('DOMContentLoaded', e => {
  /* Start filter menus */
  const modalBtns = document.querySelectorAll('.btn-filter-menu');
  const modals = document.querySelectorAll('.filter-menu');
  const modalData = [];

  const ToggleCustomModal = (e, i) => {
    const {
      modal,
      btns
    } = modalData[i];
    modalData.forEach(menu => {
      if (modal !== menu.modal) {
        if (menu.modal.classList.contains('show')) {
          menu.btns.forEach(btn => {
            btn.setAttribute('aria-expanded', 'false');
          });
          menu.modal.classList.remove('show');
        }
      }
    });
    if (!modal || !btns) return;

    if (modal.classList.contains('show')) {
      btns.forEach(btn => {
        btn.setAttribute('aria-expanded', 'false');
      });
      modal.classList.remove('show');
      return;
    }

    btns.forEach(btn => {
      btn.setAttribute('aria-expanded', 'true');
    });
    modal.classList.add('show');
  }; // Initialize modals


  for (let i = 0; i < modals.length; i++) {
    const modalId = modals[i].id;
    const btnArr = [];

    for (let i = 0; i < modalBtns.length; i++) {
      if (modalBtns[i].getAttribute('aria-controls') === '#' + modalId) {
        btnArr.push(modalBtns[i]);
      }
    }

    modalData.push({
      modal: modals[i],
      btns: btnArr
    });

    for (let i = 0; i < btnArr.length; i++) {
      btnArr[i].addEventListener('click', ToggleCustomModal.bind(null, e, modalData.length - 1));
    }
  } // Close menu when clicking outside of menu


  const CloseMenuOnOutsideClick = e => {
    let menus = document.querySelectorAll('.filter-menu');
    const btns = Array.prototype.slice.call(modalBtns);
    if (btns.includes(e.target)) return;
    menus.forEach(menu => {
      if (menu !== e.target && !menu.contains(e.target)) {
        modalData.forEach(data => {
          if (data.modal === menu) {
            if (data.modal.classList.contains('show')) {
              data.btns.forEach(btn => {
                btn.setAttribute('aria-expanded', 'false');
              });
              data.modal.classList.remove('show');
            }
          }
        });
      }
    });
  };

  document.addEventListener('mouseup', CloseMenuOnOutsideClick);
  document.addEventListener('touchend', CloseMenuOnOutsideClick);
  /* End filter menus */

  /* Start filtering functionality */

  /* let filters = {
      flavor: [],
      size: [],
      type: [],
  }
  let sort = 'a-z';
   // Clear all filters and update checkbox inputs
  const ClearFilters = () => {
      filters = {
          flavor: [],
          size: [],
          type: [],
      };
      containers.forEach(container => {
          const filterInputs = container.querySelectorAll('input[type="checkbox"]');
          filterInputs.forEach(input => {
              input.checked = false;
          });
      });
      UpdateFilterBadges(filters);
  }
   // Remove specific filter and update the associated checkbox
  const RemoveFilter = (filter, type) => {
      filters[type] = filters[type].filter(f => f !== filter);
      containers.forEach(container => {
          const filterInputs = container.querySelectorAll('input[type="checkbox"]');
          filterInputs.forEach(input => {
              if (input.name === filter)
              input.checked = false;
          });
      });
      UpdateFilterBadges(filters);
  }
   // Delegate what to do when the badge is clicked
  const BadgeAction = e => {
      const action = e.currentTarget.getAttribute('data-action');
      if (action === 'clear') {
          ClearFilters();
          return;
      }
      const type = e.currentTarget.getAttribute('data-filter');
      RemoveFilter(action, type);
  }
  
  // Update the DOM with filter badge buttons 
  const UpdateFilterBadges = (filters) => {
      const filterRows = document.querySelectorAll('.badge-container');
      if (filterRows) {
           filterRows.forEach(filterRow => {
              let badges = filterRow.querySelectorAll('.btn-filter-badge');
              badges.forEach(badge => {
                  badge.removeEventListener('click', BadgeAction);
              });
  
              filterRow.innerHTML = '';
              let isFiltering = false;
              for (filterType in filters) {
                  if (filters.hasOwnProperty(filterType)) {
                      filters[filterType].forEach(filter => {
                          const newFilter = document.createElement('button');
                          newFilter.classList = 'btn btn-filter-badge';
                          newFilter.setAttribute('data-action', filter);
                          newFilter.setAttribute('data-filter', filterType)
                          newFilter.innerHTML = filter + '<span></span>';
                          filterRow.append(newFilter);
                          if (!isFiltering) isFiltering = true;
                      });
                  }
              }
              if (isFiltering) {
                  clearFilter = document.createElement('button');
                  clearFilter.classList = 'btn btn-filter-badge btn-filter-badge-clear';
                  clearFilter.setAttribute('data-action', 'clear');
                  clearFilter.innerHTML = 'Clear Filters<span></span>';
                  filterRow.append(clearFilter);
              }
  
              badges = filterRow.querySelectorAll('.btn-filter-badge');
              badges.forEach(badge => {
                  badge.addEventListener('click', BadgeAction);
              });
          });
       }
       UpdateProductDOM(products, filters, sort);
  }
   // Toggle filters when checkbox is changed
  const ToggleFilter = (e) => {
      const type = e.currentTarget.getAttribute('data-filter');
      if (e.currentTarget.checked) {
          if (!filters[type].includes(e.currentTarget.name)) {
              filters[type].push(e.currentTarget.name);
          }
      } else {
          filters[type] = filters[type].filter(f => f !== e.currentTarget.name);
      }
      SyncInput(e.currentTarget);
      UpdateFilterBadges(filters);
  }
   // Sort-by toggler
  const ToggleSort = e => {
      sort = e.currentTarget.value;
      SyncInput(e.currentTarget);
      UpdateProductDOM(products, filters, sort);
  }
   // Keep checkboxes and radio buttons synced between mobile and desktop versions
  const SyncInput = input => {
      if (input.type === 'checkbox') {
          const inputs = document.querySelectorAll('input[type=checkbox]');
          inputs.forEach((i) => {
              if (i.name === input.name) {
                  i.checked = input.checked;
              }
          });
      } else if (input.type === 'radio') {
          const inputs = document.querySelectorAll('input[type=radio]');
          inputs.forEach((i) => {
              if (i.value === input.value) {
                  i.checked = input.checked;
              }
          });
      }
  }
  
  // Initialize filters with eventlisteners on the checkboxes and radio buttons
  const containers = document.querySelectorAll('.filters-container');
  if (containers) {
      containers.forEach(container => {
          const filterInputs = container.querySelectorAll('input[type="checkbox"]');
          filterInputs.forEach(input => {
              input.addEventListener('change', ToggleFilter);
          });
          const sortInputs = container.querySelectorAll('input[data-filter="sort"]');
          sortInputs.forEach(input => {
              input.addEventListener('change', ToggleSort);
          });
      });
  } */

  /* End filter options */

  /* Filter and display products */

  /* const FilterProducts = (products, filters, sort) => {
       let isFiltering = false;
      for (filterType in filters) {
          if (filters.hasOwnProperty(filterType)) {
              filters[filterType].forEach(filter => {
                  if (!isFiltering) isFiltering = true;
              });
          }
      }
      if (isFiltering) {
           // Filter by flavors
          if (filters['flavor'].length > 0) {
              products = products.filter(product => {
                  for (let i = 0; i < filters['flavor'].length; i++) {
                      if (product['flavor'] === filters['flavor'][i]) {
                          return true;
                      }
                  }
                  return false;
              });
          }
           // Filter by sizes
          if (filters['size'].length > 0) {
              products = products.filter(product => {
                  for (let i = 0; i < filters['size'].length; i++) {
                      if (product['size'].includes(filters['size'][i])) {
                          return true;
                      }
                  }
                  return false;
              });
          }
           // Filter by types
          if (filters['type'].length > 0) {
              products = products.filter(product => {
                  for (let i = 0; i < filters['type'].length; i++) {
                      if (product['type'] === filters['type'][i]) {
                          return true;
                      }
                  }
                  return false;
              });
          }
      }
       // Sort products
      if (sort === 'a-z') {
          products.sort((a, b) => {            
              const titleA = a.title.toUpperCase();
              const titleB = b.title.toUpperCase();
              if (titleA < titleB) {
                  return -1;
              }
              if (titleA > titleB) {
                  return 1;
              }
              return 0;
          });
      } else if (sort === 'z-a') {
          products.sort((a, b) => {            
              const titleA = a.title.toUpperCase();
              const titleB = b.title.toUpperCase();
              if (titleA < titleB) {
                  return 1;
              }
              if (titleA > titleB) {
                  return -1;
              }
              return 0;
          });
      }
       return products;
  }
   const UpdateProductDOM = (products, filters, sort) => {
      const shopProductsContainer = document.querySelector('#products-container');
      if (!shopProductsContainer) return;
      shopProductsContainer.innerHTML = '';
       products = FilterProducts(products, filters, sort);
       products.forEach(p => {
          const newProduct = document.createElement('a');
          newProduct.classList = 'col product no-hover-line';
          newProduct.href = p.url;
  
          let html = '<div class="image-holder">';
          if (p.image) {
              html += `<img class="product-image img-fluid" src="${p.image}" alt="${p.title}" loading="lazy">`;
          }
          if (p.hoverImage) {
              html += `<img class="product-image-hover img-fluid" src="${p.hoverImage}" alt="" loading="lazy">`;
          }
          html += `</div>
              <div class="product-info">
                  <p>BUTTER</p>
                  <h3>${p.title}</h3>
              </div>`
  
          newProduct.innerHTML = html;
          shopProductsContainer.append(newProduct);
      });
       const numResultsContainers = document.querySelectorAll('.num-results');
      numResultsContainers.forEach(container => {
          container.innerHTML = 'Showing ' + (products.length === 1 ? '1 result' : (products.length + ' results'));
      });
  } */

  /* End filter and display products */
  //  Initialize products. Get global products variable from inline script 

  /* if (products) {
      UpdateProductDOM(products, filters, sort);
  } */
});
},{}],"related-articles.js":[function(require,module,exports) {
;

(function () {
  // Go through each related-article div on the page.
  //$('[related-articles]').each( function( $e ){
  document.querySelectorAll('[related-articles]').forEach(container => {
    let url = container.getAttribute('data-url');
    fetch(url).then(function (res) {
      return res.text();
    }).then(function (res) {
      let temp = document.createElement('div');
      temp.innerHTML = res;
      let items = temp.querySelectorAll('.related-article');
      items = [...items];
      let curHandle = container.getAttribute('data-handle');
      items = items.filter(item => {
        if (item.getAttribute('data-handle') !== curHandle) {
          return true;
        }

        return false;
      });
      items = [...items];
      let tempItems = [];

      while (items.length < 4) {
        items.forEach(item => {
          tempItems.push(item.cloneNode(true));
        });
        items = [...items, ...tempItems];
      }

      items.forEach((item, i) => {
        container.appendChild(item);
      });
      document.querySelectorAll('.page-section-articles-carousel .swiper-container').forEach(swiper => {
        let id = swiper.closest('.page-section-articles-carousel').id;
        const articleSwiper = new Swiper(swiper, {
          slidesPerView: 1,
          spaceBetween: 16,
          loop: true,
          loopedSlides: 5,
          navigation: {
            nextEl: '#' + id + ' .btn-next',
            prevEl: '#' + id + ' .btn-prev'
          },
          breakpoints: {
            640: {
              slidesPerView: 2
            },
            1024: {
              slidesPerView: 3
            }
          }
        });
      });
    }).catch(function (err) {
      console.warn('Error fetching related articles.', err);
    });
  });
})();
},{}],"mx-sidebar-filter.js":[function(require,module,exports) {
const intersection = (arr1, arr2) => {
  const res = [];

  for (let i = 0; i < arr1.length; i++) {
    if (!arr2.includes(arr1[i])) {
      continue;
    }

    ;
    res.push(arr1[i]);
  }

  ;
  return res;
};

const intersectMany = function intersectMany() {
  for (var _len = arguments.length, arrs = new Array(_len), _key = 0; _key < _len; _key++) {
    arrs[_key] = arguments[_key];
  }

  let res = arrs[0].slice();

  for (let i = 1; i < arrs.length; i++) {
    res = intersection(res, arrs[i]);
  }

  ;
  return res;
};

const sortbyFeatured = (a, b) => {
  a = +a.getAttribute('data-index');
  b = +b.getAttribute('data-index');
  if (a < b) return -1;
  if (a > b) return 1;
  return 0;
};

const sortbyTitleAscending = (a, b) => {
  let titleA = a.getAttribute('data-title').toLowerCase();
  let titleB = b.getAttribute('data-title').toLowerCase();
  if (titleA < titleB) return -1;
  if (titleA > titleB) return 1;
  return 0;
};

const sortbyTitleDescending = (a, b) => {
  let titleA = a.getAttribute('data-title').toLowerCase();
  let titleB = b.getAttribute('data-title').toLowerCase();
  if (titleA > titleB) return -1;
  if (titleA < titleB) return 1;
  return 0;
};

const sortbyDateDescending = (a, b) => {
  let dateA = new Date(a.getAttribute('data-date').split(' ')[0].replace(/-/g, "/"));
  let dateB = new Date(b.getAttribute('data-date').split(' ')[0].replace(/-/g, "/"));
  if (dateA > dateB) return -1;
  if (dateA < dateB) return 1;
  return 0;
};

const sortbyDateAscending = (a, b) => {
  let dateA = new Date(a.getAttribute('data-date').split(' ')[0].replace(/-/g, "/"));
  let dateB = new Date(b.getAttribute('data-date').split(' ')[0].replace(/-/g, "/"));
  if (dateA < dateB) return -1;
  if (dateA > dateB) return 1;
  return 0;
};

(function ($) {
  const SidebarFilter = function SidebarFilter($container) {
    let app = {
      container: $container,
      groups: [],
      selected: [],
      filtering: false,
      init: function init() {
        app.filterGroups = app.container.find('[filter-group]');
        app.filterToggles = app.container.find('[filter-toggle]');
        app.sortbyToggles = app.container.find('[sortby-toggle]');
        app.filterGroups.each(function () {
          app.selected.push({
            handle: $(this).data('group'),
            filters: []
          });
        });
        app.filterToggles.each(function () {
          $(this).on('click', function () {
            app.toggleFilter($(this));
          });
        });
        let includesFeatured = false;
        app.sortbyToggles.each(function () {
          $(this).on('click', function () {
            app.sort($(this));
          });

          if (this.getAttribute('data-sortby') === 'featured') {
            includesFeatured = true;
          }
        });

        if (includesFeatured) {
          app.sort(null, sortbyFeatured);
        } else {
          app.sort(null, sortbyTitleAscending);
        }

        app.checkCollection();
        app.checkHash();
        app.filter();
      },
      checkHash: function checkHash() {
        let hash = window.location.hash;

        if (hash.indexOf('tag-filter') > -1) {
          hash = hash.replace('#tag-filter=', '');
          hash = hash.split('|');
          hash.forEach(group => {
            let filters = group.split('=');
            const handle = filters[0];
            filters = filters[1].split(',');
            filters = filters.map(filter => {
              return handle + '_' + filter;
            });
            let selection = app.selected.find(selected => {
              return selected.handle == handle;
            });

            if (selection != undefined) {
              filters.forEach(filter => {
                selection.filters.push(filter);
              });
            }
          });
        }
      },
      checkCollection: function checkCollection() {
        const path = window.location.pathname;

        if (path.indexOf('collections') > -1) {
          const collection = path.split('/').pop();

          if ($('[data-filter-without-group="' + collection + '"]').length > 0) {
            const data = $('[data-filter-without-group="' + collection + '"]').data();
            const handle = data.group;
            let selection = app.selected.find(selected => {
              return selected.handle == handle;
            });
            if (selection != undefined) selection.filters.push(data.filter);
          }
        }
      },
      toggleFilter: function toggleFilter($el) {
        let data = $el.data(); // Clear all button

        if (data.group === "clear-all-filters") {
          app.selected = [];
          app.filterGroups.each(function () {
            app.selected.push({
              handle: $(this).data('group'),
              filters: []
            });
          });
        } else {
          let group = app.selected.find(group => group.handle == data.group);
          let exists = group.filters.find(filter => filter == data.filter);

          if (exists == undefined) {
            group.filters.push(data.filter);
          } else {
            group.filters = group.filters.filter(filter => data.filter !== filter);
          }
        }

        app.filter();
      },

      filter() {
        // reset and set the toggle controls
        $('[filter-toggle]').removeClass('active'); // Added for checkboxes

        $('[filter-toggle] input').prop('checked', false); // build a group of arrays for identifiers and get the intersection

        let cids = [];
        app.filtering = false;
        app.selected.forEach(group => {
          let group_cids = [];
          group.filters.forEach(filter => {
            // show the group toggles
            $('[data-group="' + group.handle + '"][data-filter="' + filter + '"]').addClass('active'); // Added for checkboxes

            $('[data-group="' + group.handle + '"][data-filter="' + filter + '"] input').prop('checked', true);
            $('[mx-filter-results] [filter-result]').each(function () {
              let id = $(this).attr('data-product-id');

              if ($(this).hasClass(filter)) {
                group_cids.push(parseInt(id));
              }
            });
          });

          if (group_cids.length > 0) {
            cids.push(group_cids);
            app.filtering = true;
          }
        });
        let num_results = 0;

        if (app.filtering) {
          cids = intersectMany(...cids); // find the container with results and show only the ones in the intersect array 

          $('[mx-filter-results] [filter-result]').each(function () {
            if (cids.indexOf(parseInt($(this).attr('data-product-id'))) > -1) {
              $(this).show();
              num_results++;
            } else {
              $(this).hide();
            }
          });
        }

        if (!app.filtering) {
          app.filtering = false;
          $('[mx-filter-results] [filter-result]').show();
          $('[mx-filter-results] [filter-result]').each(() => {
            $(this).show();
            num_results++;
          });
        }

        $('.num-results').html('Showing ' + num_results + (num_results === 1 ? ' result' : ' results'));
        document.dispatchEvent(new CustomEvent('mx_sidebar_filter.filtered', {
          detail: {
            'data': app
          }
        }));
        app.updateHash();
      },

      sort: function sort($el, init) {
        const container = $('[mx-filter-results]');
        let items = [];
        $(container).find('[filter-result]').each(function () {
          items.push(this);
        });

        if (init) {
          // Default sorting order on init
          items.sort(init);
        } else {
          $el.find('input').prop('checked', true);

          switch ($el.data().sortby) {
            case 'featured':
              {
                items.sort(sortbyFeatured);
                break;
              }

            case 'title-ascending':
              {
                items.sort(sortbyTitleAscending);
                break;
              }

            case 'title-descending':
              {
                items.sort(sortbyTitleDescending);
                break;
              }

            case 'date-ascending':
              {
                items.sort(sortbyDateAscending);
                break;
              }

            case 'date-descending':
              {
                items.sort(sortbyDateDescending);
                break;
              }

            default:
              break;
          }
        }

        items.forEach(item => {
          $(item).appendTo(container);
        });
      },
      updateHash: function updateHash() {
        if (!app.filtering) {
          window.location.hash = window.location.pathname;
        }

        if (app.filtering) {
          let hash = '#tag-filter=';
          let groups = [];
          app.selected.forEach(selection => {
            let filters_ = [];

            if (selection.filters.length > 0) {
              selection.filters.forEach(filter => {
                filters_.push(filter.replace(selection.handle, '').replace('_', ''));
              });
              filters_ = filters_.join(',');
              filters_ = selection.handle + '=' + filters_;
              groups.push(filters_);
            }
          });

          if (groups.length > 0) {
            hash = hash + groups.join('|');
            window.location.hash = hash;
          }
        }
      }
    };
    return app;
  };

  if ($('[mx-sidebar-filter]').length > 0) {
    const sidebarFilter = SidebarFilter($('[mx-sidebar-filter]'));
    sidebarFilter.init();
  }

  $('.mobile-filter').on('click', function (e) {
    $('.sidebar-filters').toggleClass('open');
  });
})(jQuery);
},{}],"takeovers.js":[function(require,module,exports) {
window.addEventListener('DOMContentLoaded', e => {
  // Search panel
  const searchButtons = document.querySelectorAll('.search-btn');
  const searchButton = document.querySelector('#search-btn');
  const searchPanel = document.querySelector('#search-panel');
  const navbar = document.querySelector('#top-header');
  const body = document.querySelector('body');

  const ToggleSearchPanel = (e, close) => {
    let isExpanded = null;

    if (close) {
      isExpanded = 'true';
    } else {
      isExpanded = searchButton.getAttribute('aria-expanded');
      ToggleTakeoverMenu(null, true);
    }

    if (isExpanded === 'true') {
      searchButton.setAttribute('aria-expanded', 'false');
      searchPanel.setAttribute('aria-hidden', 'true');
      searchPanel.classList.remove('open');
      navbar.classList.remove('search-open');
      return;
    }

    searchButton.setAttribute('aria-expanded', 'true');
    searchPanel.setAttribute('aria-hidden', "false");
    searchPanel.classList.add('open');
    navbar.classList.add('search-open');
    const searchInput = searchPanel.querySelector('#search-terms');
    searchInput.focus();
    searchInput.select();
  };

  searchButtons.forEach(btn => {
    btn.addEventListener('click', ToggleSearchPanel);
  }); // Takeover menu

  const takeoverMenuButton = document.querySelector('#takeover-menu-btn');
  const takeoverMenu = document.querySelector('#takeover-menu');

  const ToggleTakeoverMenu = (e, close) => {
    let isExpanded = null;

    if (close) {
      isExpanded = 'true';
    } else {
      isExpanded = takeoverMenuButton.getAttribute('aria-expanded');
      ToggleSearchPanel(null, true);
    }

    if (isExpanded === 'true') {
      takeoverMenuButton.setAttribute('aria-expanded', 'false');
      takeoverMenu.setAttribute('aria-hidden', 'true');
      navbar.classList.remove('takeover-open');
      takeoverMenu.classList.remove('takeover-open');
      body.style.overflow = 'auto';
      return;
    }

    takeoverMenuButton.setAttribute('aria-expanded', 'true');
    takeoverMenu.setAttribute('aria-hidden', 'false');
    navbar.classList.add('takeover-open');
    takeoverMenu.classList.add('takeover-open');
    body.style.overflow = 'hidden';
  };

  takeoverMenuButton.addEventListener('click', ToggleTakeoverMenu);
});
},{}],"splitting.min.js":[function(require,module,exports) {
var define;
!function (n, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : n.Splitting = t();
}(this, function () {
  "use strict";

  var u = document,
      l = u.createTextNode.bind(u);

  function d(n, t, e) {
    n.style.setProperty(t, e);
  }

  function f(n, t) {
    return n.appendChild(t);
  }

  function p(n, t, e, r) {
    var i = u.createElement("span");
    return t && (i.className = t), e && (!r && i.setAttribute("data-" + t, e), i.textContent = e), n && f(n, i) || i;
  }

  function h(n, t) {
    return n.getAttribute("data-" + t);
  }

  function m(n, t) {
    return n && 0 != n.length ? n.nodeName ? [n] : [].slice.call(n[0].nodeName ? n : (t || u).querySelectorAll(n)) : [];
  }

  function o(n) {
    for (var t = []; n--;) t[n] = [];

    return t;
  }

  function g(n, t) {
    n && n.some(t);
  }

  function c(t) {
    return function (n) {
      return t[n];
    };
  }

  var a = {};

  function n(n, t, e, r) {
    return {
      by: n,
      depends: t,
      key: e,
      split: r
    };
  }

  function e(n) {
    return function t(e, n, r) {
      var i = r.indexOf(e);
      if (-1 == i) r.unshift(e), g(a[e].depends, function (n) {
        t(n, e, r);
      });else {
        var u = r.indexOf(n);
        r.splice(i, 1), r.splice(u, 0, e);
      }
      return r;
    }(n, 0, []).map(c(a));
  }

  function t(n) {
    a[n.by] = n;
  }

  function v(n, r, i, u, o) {
    n.normalize();
    var c = [],
        a = document.createDocumentFragment();
    u && c.push(n.previousSibling);
    var s = [];
    return m(n.childNodes).some(function (n) {
      if (!n.tagName || n.hasChildNodes()) {
        if (n.childNodes && n.childNodes.length) return s.push(n), void c.push.apply(c, v(n, r, i, u, o));
        var t = n.wholeText || "",
            e = t.trim();
        e.length && (" " === t[0] && s.push(l(" ")), g(e.split(i), function (n, t) {
          t && o && s.push(p(a, "whitespace", " ", o));
          var e = p(a, r, n);
          c.push(e), s.push(e);
        }), " " === t[t.length - 1] && s.push(l(" ")));
      } else s.push(n);
    }), g(s, function (n) {
      f(a, n);
    }), n.innerHTML = "", f(n, a), c;
  }

  var s = 0;
  var i = "words",
      r = n(i, s, "word", function (n) {
    return v(n, "word", /\s+/, 0, 1);
  }),
      y = "chars",
      w = n(y, [i], "char", function (n, e, t) {
    var r = [];
    return g(t[i], function (n, t) {
      r.push.apply(r, v(n, "char", "", e.whitespace && t));
    }), r;
  });

  function b(t) {
    var f = (t = t || {}).key;
    return m(t.target || "[data-splitting]").map(function (a) {
      var s = a["🍌"];
      if (!t.force && s) return s;
      s = a["🍌"] = {
        el: a
      };

      var n = e(t.by || h(a, "splitting") || y),
          l = function (n, t) {
        for (var e in t) n[e] = t[e];

        return n;
      }({}, t);

      return g(n, function (n) {
        if (n.split) {
          var t = n.by,
              e = (f ? "-" + f : "") + n.key,
              r = n.split(a, l, s);
          e && (i = a, c = (o = "--" + e) + "-index", g(u = r, function (n, t) {
            Array.isArray(n) ? g(n, function (n) {
              d(n, c, t);
            }) : d(n, c, t);
          }), d(i, o + "-total", u.length)), s[t] = r, a.classList.add(t);
        }

        var i, u, o, c;
      }), a.classList.add("splitting"), s;
    });
  }

  function N(n, t, e) {
    var r = m(t.matching || n.children, n),
        i = {};
    return g(r, function (n) {
      var t = Math.round(n[e]);
      (i[t] || (i[t] = [])).push(n);
    }), Object.keys(i).map(Number).sort(x).map(c(i));
  }

  function x(n, t) {
    return n - t;
  }

  b.html = function (n) {
    var t = (n = n || {}).target = p();
    return t.innerHTML = n.content, b(n), t.outerHTML;
  }, b.add = t;
  var T = n("lines", [i], "line", function (n, t, e) {
    return N(n, {
      matching: e[i]
    }, "offsetTop");
  }),
      L = n("items", s, "item", function (n, t) {
    return m(t.matching || n.children, n);
  }),
      k = n("rows", s, "row", function (n, t) {
    return N(n, t, "offsetTop");
  }),
      A = n("cols", s, "col", function (n, t) {
    return N(n, t, "offsetLeft");
  }),
      C = n("grid", ["rows", "cols"]),
      M = "layout",
      S = n(M, s, s, function (n, t) {
    var e = t.rows = +(t.rows || h(n, "rows") || 1),
        r = t.columns = +(t.columns || h(n, "columns") || 1);

    if (t.image = t.image || h(n, "image") || n.currentSrc || n.src, t.image) {
      var i = m("img", n)[0];
      t.image = i && (i.currentSrc || i.src);
    }

    t.image && d(n, "background-image", "url(" + t.image + ")");

    for (var u = e * r, o = [], c = p(s, "cell-grid"); u--;) {
      var a = p(c, "cell");
      p(a, "cell-inner"), o.push(a);
    }

    return f(n, c), o;
  }),
      H = n("cellRows", [M], "row", function (n, t, e) {
    var r = t.rows,
        i = o(r);
    return g(e[M], function (n, t, e) {
      i[Math.floor(t / (e.length / r))].push(n);
    }), i;
  }),
      O = n("cellColumns", [M], "col", function (n, t, e) {
    var r = t.columns,
        i = o(r);
    return g(e[M], function (n, t) {
      i[t % r].push(n);
    }), i;
  }),
      j = n("cells", ["cellRows", "cellColumns"], "cell", function (n, t, e) {
    return e[M];
  });
  return t(r), t(w), t(T), t(L), t(k), t(A), t(C), t(S), t(H), t(O), t(j), b;
});
},{}],"animation.js":[function(require,module,exports) {
"use strict";

var _splittingMin = _interopRequireDefault(require("./splitting.min.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

gsap.registerPlugin(ScrollTrigger);
ScrollTrigger.matchMedia({
  "(min-width: 992px)": function minWidth992px() {
    // FAQ animations
    gsap.utils.toArray(".page-section-faqs").forEach(ele => {
      ScrollTrigger.create({
        trigger: ele,
        start: "top 70px",
        end: "bottom center",
        pin: ".faq-sticky-header"
      });
    });
    gsap.utils.toArray(".faq-sticky-header").forEach(ele => {
      gsap.to(ele, {
        scrollTrigger: {
          trigger: ".page-section-faqs",
          start: 'bottom bottom',
          end: 'bottom 80%',
          scrub: 1
        },
        opacity: 0
      });
    }); // Three column content section

    gsap.utils.toArray(".three-column-container .content").forEach((ele, i) => {
      gsap.from(ele, {
        scrollTrigger: {
          trigger: ele,
          start: 'bottom bottom'
        },
        opacity: 0,
        y: 30,
        duration: 1,
        delay: i * .2,
        ease: 'power4.out'
      });
    }); // Ribbon marquees

    gsap.utils.toArray(".ribbon-textpath").forEach(ele => {
      gsap.to(ele, {
        scrollTrigger: {
          trigger: ele,
          start: 'top bottom',
          end: '+=1000',
          scrub: .5
        },
        attr: {
          startOffset: "1500px"
        }
      });
    });
  },
  "(max-width: 992px)": function maxWidth992px() {},
  "all": function all() {
    // Home hero animation
    gsap.utils.toArray(".home-hero-anim").forEach((ele, i) => {
      gsap.from(ele, {
        scrollTrigger: {
          trigger: ele,
          start: 'top bottom'
        },
        autoAlpha: 0,
        y: 50,
        duration: 1,
        ease: 'power4.out'
      });
    }); // FAQ block fade in

    gsap.utils.toArray(".faq-block").forEach((ele, i) => {
      gsap.from(ele, {
        scrollTrigger: {
          trigger: ele,
          start: 'bottom bottom',
          end: '+=1000'
        },
        autoAlpha: 0,
        //y: 30,
        duration: 1,
        ease: 'power4.out'
      });
    }); // General fade in (up)

    gsap.utils.toArray(".fade-in").forEach(ele => {
      gsap.from(ele, {
        scrollTrigger: {
          trigger: ele,
          start: 'top bottom',
          end: '+=1000'
        },
        autoAlpha: 0,
        y: 50,
        duration: 1,
        ease: 'power4.out'
      });
    }); // General fade in from right to left

    gsap.utils.toArray(".fade-in-to-left").forEach(ele => {
      gsap.from(ele, {
        scrollTrigger: {
          trigger: ele,
          start: 'top bottom',
          end: '+=1000'
        },
        autoAlpha: 0,
        x: 50,
        duration: 1,
        delay: .2,
        ease: 'power4.out'
      });
    }); // General large heading animation

    gsap.utils.toArray('.animate-text').forEach(ele => {
      gsap.to(ele, {
        scrollTrigger: {
          trigger: ele,
          start: 'bottom bottom',
          end: '+=1000',
          onEnter: () => {
            ele.classList.add('animate-in');
          }
        }
      });
    }); // Featured product card on article pages

    gsap.utils.toArray(".featured-product-card").forEach(ele => {
      gsap.to(ele, {
        scrollTrigger: {
          trigger: ele,
          start: 'bottom bottom',
          toggleClass: {
            targets: ele,
            className: "is-active"
          }
        }
      });
    });
  }
});
window.addEventListener('DOMContentLoaded', e => {
  const targets = document.querySelectorAll('.animate-text');
  targets.forEach(target => {
    (0, _splittingMin.default)({
      target: target,
      by: 'words'
    });
  });
});
},{"./splitting.min.js":"splitting.min.js"}],"index.js":[function(require,module,exports) {
"use strict";

var _cartDrawer = _interopRequireDefault(require("./core/components/cart-drawer"));

var _productForms = _interopRequireDefault(require("./core/services/product-forms"));

var _quantityComponents = _interopRequireDefault(require("./core/services/quantity-components"));

var _cartCount = _interopRequireDefault(require("./core/components/cart-count"));

var _cart = _interopRequireDefault(require("./core/services/cart"));

var _addToCartButton = _interopRequireDefault(require("./core/components/add-to-cart-button"));

var _addToCartButtons = _interopRequireDefault(require("./core/services/add-to-cart-buttons"));

var _carts = _interopRequireDefault(require("./core/services/carts"));

require("./request-store-accordion");

require("./copy-to-clipboard");

require("./faq-accordion");

require("./modal-overlay");

require("./filtering");

require("./related-articles");

require("./mx-sidebar-filter");

require("./takeovers");

require("./animation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
*
* JS Imports
*
* */
// initialize the header nav cart display
// navCart( selectDoc( "[ws-nav-cart]") ).init();
// eventBus.dispatch( eventBus.types.AddingToCart , {});
// console.log( selectDoc('[sh-product-form]'));

/** Initialize All Add to cart forms  */
// const productFormSelector = '[sh-product-form]';
Shopify.cartService = (0, _cart.default)();
(0, _productForms.default)('[sh-product-form]');
(0, _quantityComponents.default)('[sh-quantity-component]');
(0, _cartDrawer.default)('[sh-cart-drawer]', '[sh-cart-drawer-trigger]');
(0, _cartCount.default)('[sh-cart-count]');
(0, _addToCartButtons.default)('[sh-add-to-cart]');
(0, _carts.default)('[sh-cart-wrapper]'); // Adding swiper

const swiperCarousel = new Swiper('#ProductsCarousel .swiper', {
  slidesPerView: 1,
  spaceBetween: 9,
  navigation: {
    nextEl: '#ProductsCarousel .btn-next',
    prevEl: '#ProductsCarousel .btn-prev'
  },
  breakpoints: {
    640: {
      slidesPerView: 2
    },
    992: {
      slidesPerView: 2,
      slidesOffsetBefore: -100
    },
    1200: {
      slidesPerView: 2,
      slidesOffsetBefore: -175
    },
    1440: {
      slidesPerView: 2,
      slidesOffsetBefore: -250
    }
  }
}); // Ingredients Carousel (Swiper)

const ingredientsCarousel = new Swiper('#IngredientsCarousel .swiper', {
  slidesPerView: 1,
  spaceBetween: 14,
  loop: true,
  loopedSlides: 5,
  navigation: {
    nextEl: '#IngredientsCarousel .btn-next',
    prevEl: '#IngredientsCarousel .btn-prev'
  },
  breakpoints: {
    640: {
      slidesPerView: 2
    },
    1100: {
      slidesPerView: 3
    }
  }
});

const initGalleryButtons = () => {
  document.querySelectorAll('.btn-gallery').forEach(btn => {
    btn.addEventListener('click', e => {
      let index = e.currentTarget.getAttribute('data-index');

      if (gallery) {
        gallery.activeIndex = index;
        gallery.update();
      }
    });
  });
}; // Image gallery modal swipers


const galleryThumbnails = new Swiper("#image-gallery .gallery-thumbs-swiper", {
  slidesPerView: 4,
  // freeMode: true,
  watchSlidesProgress: true,
  breakpoints: {
    768: {
      direction: 'vertical'
    }
  }
});
const gallery = new Swiper("#image-gallery .gallery-swiper", {
  spaceBetween: 10,
  navigation: {
    nextEl: "#image-gallery .btn-next",
    prevEl: "#image-gallery .btn-prev"
  },
  thumbs: {
    swiper: galleryThumbnails
  },
  keyboard: {
    enabled: true,
    onlyInViewport: false
  },
  breakpoints: {
    768: {
      direction: 'vertical'
    }
  },
  on: {
    init: initGalleryButtons
  }
}); // Back buttons

document.querySelectorAll('.btn-back').forEach(btn => {
  btn.addEventListener('click', e => {
    history.back();
  });
});
},{"./modal-overlay":"modal-overlay.js"}]},{},["index.js"], null)
//# sourceMappingURL=/index.js.map